import { system } from 'styled-system'
import get from 'lodash/get'

export const hexToRgba = (hex: string, alpha = 1): string => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16))
  return `rgba(${r},${g},${b},${alpha})`
}

export const setProperty = (
  property: string,
  value: string,
  isImportant = false,
): string => {
  if (value === null) {
    return ``
  }
  return `${property}: ${value} ${isImportant ? `!important;` : ``}`
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getColorWithOpacity(value, theme): string | null {
  if (!value) {
    return null
  }
  const [key, opacity = null] = value.split(`@`)
  const color = get(theme, key)
  if (color == null) {
    return key
  }
  return opacity == null ? color : hexToRgba(color, opacity)
}

export const colorsWithOpacity = system({
  color: {
    property: `color`,
    scale: `colors`,
    transform: getColorWithOpacity,
  },
  backgroundColor: {
    property: `backgroundColor`,
    scale: `colors`,
    transform: getColorWithOpacity,
  },
  borderColor: {
    property: `borderColor`,
    scale: `colors`,
    transform: getColorWithOpacity,
  },
})

export const backgroundGradient = system({
  background: {
    property: `background`,
    scale: `gradients`,
  },
})
